import { data } from 'services';
import { getDataField } from 'libs/common';

export const getTableParams = (t) => {
  const fields = [
    { name: 'name', title: t('form.Клиент'), width: 250, sortField: 'name' },
    {
      name: 'status',
      title: t('grid.Статус'),
      width: 160,
      sortField: 'status',
      render: (val) => data.getDictValue('benefit_types.status', val),
    },
    {
      name: 'amount',
      title: t('grid.Сумма скидки'),
      render: (_val, _, row) => getDataField(row.data, 'amount', true),
    },
    { name: 'min_amount', title: t('grid.Минимальная сумма'), width: 180, render: (_val, _, row) => getDataField(row.data, 'min_amount', true) },
    { name: 'fn', title: t('form.Номер ФН'), width: 150, render: (_val, _, row) => getDataField(row.data, 'fn') },
  ];

  // get row class
  const getRowClass = (row) => {
    let out = '';
    out += ' ' + row.status;
    return out;
  };

  return { fields, getRowClass };
};
